var React = require('react');

function UserSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.8","fillRule":"evenodd","clipRule":"evenodd","d":"M29.9214 34.2779C39.3653 34.2779 47.0193 26.6226 47.0193 17.18C47.0193 7.73736 39.3653 0.0820312 29.9214 0.0820312C20.4775 0.0820312 12.8235 7.73736 12.8235 17.18C12.8235 26.6226 20.4775 34.2779 29.9214 34.2779ZM36.6938 40.6896H23.149C10.367 40.6896 0 51.0553 0 63.8386C0 66.3953 2.07313 68.4698 4.6298 68.4698H55.2157C57.7723 68.4738 59.8428 66.4033 59.8428 63.8386C59.8428 51.0553 49.4771 40.6896 36.6938 40.6896Z","fill":"#FEFEFE"}));
}

UserSolid.defaultProps = {"width":"60","height":"69","viewBox":"0 0 60 69","fill":"none"};

module.exports = UserSolid;

UserSolid.default = UserSolid;
